export default "__VITE_ASSET__gIME90V7__"